import React from 'react';

const Ec2ExRowControls = ({toggleHideRow, instanceId, swapInstanceOrder}) => {

  const handleClick = e => {
    if (e.target.value === 'X') {
      toggleHideRow(instanceId);
    } else if (e.target.value === '^' || e.target.value === 'v') {
      swapInstanceOrder(instanceId, e.target.value === '^' ? -1 : 1);
    }
  };

  return (
    <td className="RowControls StickyColumn">
      <div>
        <button onClick={handleClick} value={'^'} className="Ec2ExDir">{'^'}</button>
        <button onClick={handleClick} value={'X'} className="Ec2ExDel">{'X'}</button>
        <button onClick={handleClick} value={'v'} className="Ec2ExDir">{'v'}</button>
      </div>
    </td>
  );

};

export default Ec2ExRowControls;


// WEBPACK FOOTER //
// ./src/components/content/ec2ResExplorer/ec2ExMain/ec2ExTableRow/ec2ExRowControls/ec2ExRowControls.js